import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogCloseButton,
  AlertDialogOverlay,
  Button,
  useDisclosure
} from '@chakra-ui/react'
import React from 'react'

export function Confirm ({ isOpen, onOpen, onClose, handleImport }: any) {


  const cancelRef = React.useRef<any>()

  return (
    <AlertDialog
    motionPreset='slideInBottom'
    leastDestructiveRef={cancelRef}
    onClose={onClose}
    isOpen={isOpen}
    isCentered
  >
    <AlertDialogOverlay />
  
    <AlertDialogContent>
      <AlertDialogHeader>Tem certeza disso?</AlertDialogHeader>
      <AlertDialogCloseButton />
      <AlertDialogBody>
        Deseja substituir o relatório atual pelo rascunho? Essa opção não pode ser desfeita.
      </AlertDialogBody>
      <AlertDialogFooter>
        <Button ref={cancelRef} onClick={onClose}>
          Cancelar
        </Button>
        <Button colorScheme='teal' ml={3} onClick={handleImport}>
          Sim, Importar
        </Button>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
  )

}